import * as React from 'react'
import { Spinner } from '../Spinner/Spinner'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { LoadingStateProps } from './types'

export const LoadingState: React.FC<LoadingStateProps> = ({
    message,
    size = 'large',
    color = 'text-blue-500',
}) => {
    const { t } = useTranslation('translations')

    const displayMessage = message || t('loadingState.default')

    const baseStyles =
        'absolute inset-0 z-5 flex flex-col items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm'

    const sizeStyles =
        size === 'large'
            ? { width: 102, height: 102 }
            : { width: 40, height: 40 }

    return (
        <div
            className={classNames(baseStyles, color)}
            data-testid="loading-state"
        >
            <Spinner size={sizeStyles.width} width={sizeStyles.height / 10} />
            <p
                className="mt-2 font-inter text-sm font-medium leading-6 text-neutral-800"
                dangerouslySetInnerHTML={{ __html: displayMessage }}
            />
        </div>
    )
}
